var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingConfig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 5C16.75 4.44772 17.1977 4 17.75 4H20.75C21.3023 4 21.75 4.44772 21.75 5C21.75 5.55228 21.3023 6 20.75 6H17.75C17.1977 6 16.75 5.55228 16.75 5Z",
    fill: "#141415"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 2C14.3023 2 14.75 2.44772 14.75 3V7C14.75 7.55228 14.3023 8 13.75 8C13.1977 8 12.75 7.55228 12.75 7V3C12.75 2.44772 13.1977 2 13.75 2Z",
    fill: "#141415"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 5C1.75 4.44772 2.19772 4 2.75 4H13.75C14.3023 4 14.75 4.44772 14.75 5C14.75 5.55228 14.3023 6 13.75 6H2.75C2.19772 6 1.75 5.55228 1.75 5Z",
    fill: "#141415"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 12C1.75 11.4477 2.19772 11 2.75 11H6.75C7.30228 11 7.75 11.4477 7.75 12C7.75 12.5523 7.30228 13 6.75 13H2.75C2.19772 13 1.75 12.5523 1.75 12Z",
    fill: "#141415"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 9C11.3023 9 11.75 9.44772 11.75 10V14C11.75 14.5523 11.3023 15 10.75 15C10.1977 15 9.75 14.5523 9.75 14V10C9.75 9.44772 10.1977 9 10.75 9Z",
    fill: "#141415"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 12C9.75 11.4477 10.1977 11 10.75 11H21.75C22.3023 11 22.75 11.4477 22.75 12C22.75 12.5523 22.3023 13 21.75 13H10.75C10.1977 13 9.75 12.5523 9.75 12Z",
    fill: "#141415"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 19C16.75 18.4477 17.1977 18 17.75 18H20.75C21.3023 18 21.75 18.4477 21.75 19C21.75 19.5523 21.3023 20 20.75 20H17.75C17.1977 20 16.75 19.5523 16.75 19Z",
    fill: "#141415"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 16C14.3023 16 14.75 16.4477 14.75 17V21C14.75 21.5523 14.3023 22 13.75 22C13.1977 22 12.75 21.5523 12.75 21V17C12.75 16.4477 13.1977 16 13.75 16Z",
    fill: "#141415"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 19C1.75 18.4477 2.19772 18 2.75 18H13.75C14.3023 18 14.75 18.4477 14.75 19C14.75 19.5523 14.3023 20 13.75 20H2.75C2.19772 20 1.75 19.5523 1.75 19Z",
    fill: "#141415"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingConfig);
export default __webpack_public_path__ + "static/media/setting-config.e443d88b52e74e2d77ac985ebfbda019.svg";
export { ForwardRef as ReactComponent };